import { Injectable } from '@angular/core';

import { LanguageStore, SUPPORTED_LANGUAGE, SUPPORTED_LOCALES } from '@store';

@Injectable()
export class TranslationConfigService {
  readonly defaultLanguage = 'en';
  readonly defaultLangCode = 'en';
  readonly defaultCountryCode = 'GB';
  readonly defaultLocale = SUPPORTED_LANGUAGE.EN;
  readonly defaultLocaleForLanguage = SUPPORTED_LOCALES;
  private readonly browserLanguage: string;
  private readonly browserLocale: string;
  private userLanguage: string;

  constructor(private languageStore: LanguageStore) {
    this.browserLanguage = navigator.language.split('-')[0];
    this.browserLocale = navigator.language;
    this.languageStore.languageCode$.subscribe((languageCode: string) => {
      this.userLanguage = languageCode;
    });
  }

  public langCode(): string {
    return this.getLanguage() ? this.getLanguage().split('-')[0] : this.defaultLangCode;
  }

  public countryCode(): string {
    return this.getLanguage() ? this.getLanguage().split('-')[1] : this.defaultCountryCode;
  }

  public getBrowserLanguage(): string {
    const language = SUPPORTED_LANGUAGE[this.browserLanguage.toUpperCase()];

    return language ? language : this.defaultLanguage;
  }

  public getBrowserLocale(): string {
    const locale = SUPPORTED_LOCALES[this.browserLocale];

    return locale
      ? locale
      : this.defaultLocaleForLanguage[this.getBrowserLanguage()] || this.defaultLocale;
  }

  public getLanguage(): string {
    return this.userLanguage ? this.userLanguage : this.getBrowserLocale();
  }
}
